import React, { useState, useEffect } from 'react';
import LineChart from 'app/shared/LineChart';
import PieChart from 'app/shared/PieChart';
import BarChart from 'app/shared/BarChart';
import Tabs from 'app/shared/Tabs';
import moment from 'moment';

const pieColor = {
	cet: ['#27C992', '#31DBA1', '#5CE3B5', '#6DF1C4', '#83F5CE'],
	tet: ['#E62F4D', '#EB5971', '#F08395', '#F5AEB9', '#FAD8DD'],
};

//different piecolor enchance but not so good looki'n
// const pieColor = {
// 	cet: ['#29f598', '#22e4ac', '#1ad7bb', '#0fbed7', '#08b3e5'],
// 	tet: ['#f11d28', '#fd3a2e', '#fe612b', '#ff872c', '#ffa12c'],
// };

const lineChartColor = {
	tet: '#E62F4D',
	cet: '#27C992',
};
const insightsMeta = {
	tet: {
		event: 'Trip',
		day: 'Daily',
	},
	cet: {
		event: 'Charging Event',
		day: 'Day',
	},
};

const tabs = {
	cet: [
		{
			key: 'soccharged',
			label: 'SoC Charged',
			icon: 'fas fa-charging-station',
			unit: '%',
		},
		{
			key: 'chargeduration',
			label: 'Charge Duration',
			icon: 'far fa-clock',
			unit: 'min',
		},
		{
			key: 'roc',
			label: 'Rate of Charge',
			icon: 'fas fa-charging-station',
			unit: '%/hr',
		},
	],
	tet: [
		{
			key: 'distance',
			label: 'Distance',
			icon: 'fas fa-road',
			unit: 'km',
		},
		{
			key: 'socconsumed',
			label: 'SoC Consumed',
			icon: 'fas fa-battery-half',
			unit: '%',
		},
		{
			key: 'range',
			label: 'Range',
			icon: 'fas fa-road',
			unit: 'km',
		},
	],
};

function Utilization(props) {
	const [activeTab, setActiveTab] = useState(tabs[props.type][0].key);
	const [insightType, setInsightType] = useState('event');
	const [selectedLineChart, setSelectedLineChart] = useState(0);
	const [activeMarker, setActiveMarker] = useState(null);
	const [activeLegend, setActiveLegend] = useState();

	useEffect(() => {
		initPreserveState();
		// eslint-disable-next-line
	}, []);
	const initPreserveState = () => {
		let pageKey = props.path.replaceAll('/', '');

		let metaData = JSON.parse(sessionStorage.getItem(pageKey));
		if (metaData === null) return;

		if (metaData.marker) {
			setActiveMarker(metaData.marker);
		}
		if (metaData.activeDate) {
			setSelectedLineChart(metaData.activeDate);
		}

		if (metaData.chargeTab && props.type === 'cet') {
			setActiveTab(metaData.chargeTab);
		}
		if (metaData.tripTab && props.type === 'tet') {
			setActiveTab(metaData.tripTab);
		}
		if (metaData.insightType) {
			setInsightType(metaData.insightType);
		}
	};
	const getTripTrend = () => {
		let data = props.tripInsight[activeTab].trend[insightType];
		let lineData = [];

		for (let idx in data) {
			lineData.push({
				x: moment(data[idx].date).format('MMM DD'),
				y: data[idx].value,
				date: moment(data[idx].date).format('MMM DD, hh:mm A'),
			});
		}
		return lineData;
	};

	const getLabelRearranged = (label, unit) => {
		let splitted = label.includes('-') ? label.split('-') : label.split(' ');
		if (!unit) return splitted.join(' - ');

		// splitted[0] = splitted[0] + unit;
		if (splitted[1]) {
			splitted[1] = splitted[1] + `${unit}`;
			// splitted[0] = splitted[0] + unit;
		} else {
			splitted[0] = splitted[0] + `${unit}`;
		}

		return splitted.join(' - ');
	};
	const getDistribution = () => {
		let data = props.tripInsight[activeTab].dist.overall[insightType];
		let barData = [];
		let activeTabMeta = tabs[props.type];

		let activeWidgetTab = activeTabMeta.find((tab) => tab.key === activeTab);

		for (let idx in data) {
			barData.push({
				range: getLabelRearranged(data[idx].range, activeWidgetTab.unit),
				value: data[idx].value,
			});
		}
		return barData;
	};

	const getPieBreakup = () => {
		let data = props.tripInsight[activeTab].dist[insightType][selectedLineChart];
		let pieData = [];
		let activeTabMeta = tabs[props.type];
		let activeWidgetTab = activeTabMeta.find((tab) => tab.key === activeTab);
		for (let idx in data.data) {
			pieData.push({
				id: data.data[idx].range,
				label: getLabelRearranged(data.data[idx].range, activeWidgetTab.unit),
				value: data.data[idx].value,
			});
		}
		return pieData;
	};

	const getPieDate = (type) => {
		let data = props.tripInsight[activeTab].dist[insightType][selectedLineChart];
		return moment(data.date).format('MMM DD ');
	};

	const handleLineSelect = (point) => {
		setSelectedLineChart(point.index);
		setActiveMarker(point.data.x);
		props.updatePreserveState('marker', point.data.x);
		props.updatePreserveState('activeDate', point.index);
	};

	const getLineChartTooltipLabel = () => {
		let activeWidgetTab = tabs[props.type].find((tab) => tab.key === activeTab);

		return {
			label: activeWidgetTab.label,
			unit: activeWidgetTab.unit,
			icon: activeWidgetTab.icon,
		};
	};

	const getLegendBreaked = (legend) => {
		if (legend.split('-').length > 1) {
			return (
				<>
					<div>{legend.split('-')[0].replaceAll(' ', '')}</div>
					<div style={{ textAlign: 'center' }}> - </div>
					<div style={{ textAlign: 'right' }}>
						{parseInt(legend.split('-')[1].replaceAll(' ', ''))}
					</div>
					<div style={{ textAlign: 'left', marginLeft: 2, minWidth: 10 }}>
						{legend.split('-')[1].replace(/[0-9]/g, '')}
					</div>
				</>
			);
		} else {
			return (
				<>
					<div>{'>'}</div>
					<div style={{ textAlign: 'center' }}> - </div>
					<div style={{ textAlign: 'right' }}>
						{parseInt(legend.split('>')[1].replaceAll(' ', ''))}{' '}
					</div>
					<div style={{ textAlign: 'left', marginLeft: 2, minWidth: 10 }}>
						{legend.split('>')[1].replace(/[0-9]/g, '')}
					</div>
				</>
			);
		}
	};

	return (
		<div className="Row">
			<div className="Row-Tab">
				<Tabs
					tabs={tabs[props.type]}
					onChange={(tab) => {
						setActiveTab(tab);
						props.updatePreserveState(props.type === 'cet' ? 'chargeTab' : 'tripTab', tab);
					}}
					activeTab={activeTab}
				/>
				<Tabs
					onChange={(tab) => {
						setInsightType(tab);
						props.updatePreserveState('insightType', tab);
					}}
					activeTab={insightType}
					tabs={[
						{ key: 'event', label: props.type === 'cet' ? 'Charging Event' : 'Trip' },
						{ key: 'day', label: 'Daily' },
					]}
				/>
			</div>
			<div className="Row-Content">
				<div className="Trend">
					<div className="TripTrend">
						{/* <div className="Title">Avg Charge aggregated</div> */}
						<div className="GraphView">
							<LineChart
								id="chargeTrend"
								data={getTripTrend(props.type) || []}
								gradient={true}
								enableCrosshair={false}
								color={lineChartColor[props.type]}
								onSelect={handleLineSelect}
								tooltipLabels={getLineChartTooltipLabel(props.type)}
								activeMarker={activeMarker}
								mouseMoveAction
							/>
						</div>
					</div>
					<div className="DailyBreakup">
						<div className="Title"> {getPieDate(props.type)} </div>
						<div className="GraphView">
							<div className="Chart">
								<PieChart
									data={getPieBreakup(props.type)}
									color={pieColor[props.type]}
									onMouseMove={(legendKey) => setActiveLegend(legendKey)}
									onMouseLeave={() => setActiveLegend('')}
								/>
							</div>
							<div className="Legend">
								<ul>
									{getPieBreakup(props.type).map((legend, key) => {
										return (
											<li className="legendItem" key={key}>
												<div
													className={activeLegend === legend.label ? 'divActive' : ''}
													style={{ background: pieColor[props.type][key] }}
												></div>{' '}
												{/* <span>{legend.label}</span> */}
												<span>{getLegendBreaked(legend.label)}</span>
											</li>
										);
									})}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="Distribution">
					<div className="Title">
						{getLineChartTooltipLabel(props.type).label}{' '}
						<small style={{ color: 'gray' }}>
							({moment(props.timerange.starttime).format('MMM DD')} -{' '}
							{moment(props.timerange.endtime).format('MMM DD')})
						</small>
						{/* {insightType === 'event' ? 'per charging event' : 'Daily'} */}
					</div>
					<div className="GraphView">
						<BarChart
							data={getDistribution(props.type)}
							color={[pieColor[props.type][0]]}
							onClick={(data) => props.fetchInsightSummary(data, activeTab, insightType)}
							axisLegends={{
								bottom:
									props.type === 'tet'
										? insightsMeta[props.type]?.[insightType] +
										  ' ' +
										  getLineChartTooltipLabel(props.type).label
										: getLineChartTooltipLabel(props.type).label +
										  ' / ' +
										  insightsMeta[props.type]?.[insightType],
								left: 'No of events (%)',
							}}
							cursor={true}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Utilization;
